// extracted by mini-css-extract-plugin
export default {"createAdCheckboxContainer":"StandartCheckbox_createAdCheckboxContainer__FOvn2","createAdCheckbox":"StandartCheckbox_createAdCheckbox__3dt7E"};